module.exports = __webpack_public_path__ + "img/cloudfiles.4541140d.png";